"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=e=>r=>{const{queryKey:t,signal:a}=r,[,s]=t;return e(s,a)};exports.withQueryParams=n;
